import { database, storage, auth } from "../../firebase";

export function setMusicHidden(uid, musicHidden, videoHidden) {
  return database
    .ref(`/users/${uid}`)
    .update({
      musicHidden: !!musicHidden,
      videoHidden: !!videoHidden,
    })
    .then(() => {
      return true;
    })
    .catch(() => false);
}

export function hideMusic(music) {
  const hidden = !!music.hidden;
  return database
    .ref(`/posts/${music.id}`)
    .update({
      hidden,
    })
    .then(() => {
      return true;
    })
    .catch(() => false);
}

export async function createNewAchievement(uid, payload) {
  const newPostKey = database.ref().child("user-achievements").push().key;
  const updates = {};
  for (const propName in payload) {
    if (payload[propName] === null || payload[propName] === undefined) {
      delete payload[propName];
    }
  }
  // updates[`/achievements/${newPostKey}`] = payload;
  updates[`/user-achievements/${uid}/${newPostKey}`] = payload;
  await database.ref().update(updates);
  return true;
}

export async function uploadImage(image) {
  const uploadSnapchot = await storage
    .ref("profile_images")
    .child(`/${image.name}-${new Date().getTime()}`)
    .put(image);
  const imageLink = await uploadSnapchot.ref.getDownloadURL();
  return imageLink;
}

export async function updateUserDetails(uid, payload) {
  for (const propName in payload) {
    if (payload[propName] === null || payload[propName] === undefined) {
      delete payload[propName];
    }
  }
  console.log('payload',payload)
  return database
    .ref(`/users/${uid}`)
    .update({
      ...payload,
    })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
}

export function setAchivementHidden(uid, achievementHidden) {
  return database
    .ref(`/users/${uid}`)
    .update({
      achievementHidden: !!achievementHidden,
    })
    .then(() => {
      return true;
    })
    .catch(() => false);
}

export function hideAchievement(uid, achievement) {
  const hidden = !!achievement.hidden;
  return database
    .ref(`/user-achievements/${uid}/${achievement.id}`)
    .update({
      hidden,
    })
    .then(() => {
      return true;
    })
    .catch(() => false);
}

export function connectLink(uid, payload) {
  return database
    .ref(`/users/${uid}`)
    .update({
      ...payload
    })
    .then(() => {
      return true;
    })
    .catch(() => false);
}

export async function updateUserEmail(email) {
  return auth.currentUser.updateEmail(email).then(()=>true).catch(()=>false)
}
